// extracted by mini-css-extract-plugin
export default {"modal-width":"Modal_modal-width__Oxx63","modal-card":"Modal_modal-card__DKadE","modal-custom-body":"Modal_modal-custom-body__4Venh","modal-body":"Modal_modal-body__IMxDR"};